export default "__VITE_ASSET__BB5Hn4eF__"